import { useForm, FieldError } from 'react-hook-form'
import { email as isEmail } from 'lib/form-validation'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button, TextInput } from 'baby-design'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Calendar } from 'baby-design/icons'
import ScrollLockModal from 'shared/ScrollLockModal'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

const GiftGiverReminderModal = NiceModal.create(() => {
  const modal = useModal()
  const { register, handleSubmit, errors } = useForm<{ email: string }>()

  const formId = 'gift-giver-reminder-form'

  const onSubmit = (data: { email: string }) => {
    // eslint-disable-next-line no-console
    console.log(data)
    modal.hide()
  }

  const getStatus = (fieldError: FieldError | undefined) => {
    if (fieldError) {
      return { type: 'error' as const, message: fieldError.message as string }
    }
    return undefined
  }

  const primaryButton = (
    <Button form={formId} size="lg" type="submit" variant="primary">
      Remind me
    </Button>
  )

  const secondaryButton = (
    <Button size="lg" variant="secondary" onClick={modal.hide}>
      No thanks
    </Button>
  )

  return (
    <ScrollLockModal
      showCloseButton
      handleClose={modal.hide}
      icon={<Calendar />}
      isOpen={modal.visible}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      subTitle="Get a reminder a few weeks before the baby shower"
      title="Need time to decide?"
    >
      <form id={formId} onSubmit={handleSubmit(onSubmit)}>
        <TextInput
          inputProps={{
            name: 'email',
            ref: register({
              validate: isEmail,
            }),
          }}
          label="Your email*"
          size="md"
          status={getStatus(errors?.email)}
        />
      </form>
    </ScrollLockModal>
  )
})

export default GiftGiverReminderModal
